import CropFreeIcon from '@mui/icons-material/CropFree';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { checkAccess } from '../../../api/mobileapi';
import { CernQrCodeValue } from '../../../api/types';
import { AdamsError, getErrorMessage } from '../../../utils/errors';
import { cameraScanningErrorsNotToBeShown } from '../../../utils/utils';
import { DividerWithText } from '../../DividerWithText/DividerWithText';
import { useHomeData } from '../../LoadHomeData/HomeDataProvider';
import { QRScanner } from '../../QRScanner/QRScanner';
import { Severity, useToast } from '../../ToastProvider/ToastProvider';
import { useTranslations } from '../../Translations/TranslationsProvider';

export const ScanAccessPoint: React.FC = () => {
    const navigate = useNavigate();
    const toast = useToast();
    const { currentLanguage } = useHomeData();
    const { translations } = useTranslations();
    const [displayQRScanner, setDisplayQRScanner] = useState(false);

    const handleScanDetect = (value: CernQrCodeValue) => {
        if (value) {
            const { accessPointCode } = value;
            setDisplayQRScanner(false);
            if (accessPointCode) {
                checkAccess({ language: currentLanguage, accessPointCode });
                navigate(`/accesspoint/${accessPointCode}`);
            } else {
                toast(translations.ERROR_NOT_ACP_QR_CODE, Severity.error);
            }
        } else {
            toast(translations.ERROR_NOT_CERN_QR_CODE, Severity.error);
        }
    };

    const handleScanError = (error: AdamsError) => {
        const errorMessage = getErrorMessage(error);
        if (errorMessage && !cameraScanningErrorsNotToBeShown.includes(errorMessage)) {
            setDisplayQRScanner(false);
            toast(errorMessage, Severity.error);
        }
    };

    const handleClose = () => {
        setDisplayQRScanner(false);
    };

    return (
        <>
            {displayQRScanner && (
                <QRScanner
                    onDetect={handleScanDetect}
                    onError={handleScanError}
                    onClose={handleClose}
                    translations={translations}
                />
            )}
            <>
                <Box my={6}>
                    <DividerWithText>{translations.GLOBAL_OR}</DividerWithText>
                </Box>

                <Box>
                    <Box my={4}>
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            size="large"
                            startIcon={<CropFreeIcon style={{ fontSize: '1rem' }} />}
                            sx={{ marginTop: 2 }}
                            onClick={() => setDisplayQRScanner(true)}
                        >
                            {translations.GLOBAL_SCAN_BUTTON}
                        </Button>
                    </Box>
                </Box>
            </>
        </>
    );
};
